import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';

interface SummaryProps {
  headerText: string;
}
const TransfersSummary = (props: SummaryProps) => {
  const { headerText } = props;

  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1a-content"
      id="panel1a-header"
      sx={{
        height: '90px',
        padding: '32px 28px',
        '& .MuiAccordionSummary-expandIconWrapper > .MuiSvgIcon-root > path': { fill: '#14191F' },
      }}
    >
      <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{headerText}</Typography>
    </AccordionSummary>
  );
};

export default TransfersSummary;
